export const zero_before_number = (number) => {
  return number < 10 ? `0${number}` : number;
};
